<script setup lang="ts" generic="S extends string">
import type { CheckboxGroupProps } from '#ui/types'

const props = defineProps<{
  legend?: string
  name: string
  options: Options<S>
  enabled?: Set<S>
  ui?: CheckboxGroupProps['ui']
  size?: CheckboxGroupProps['size']
}>()

const q = useRouteQuery(props.name, [], {
  mode: 'replace',
  transform: (value) => Array.isArray(value) ? value : [value],
})
</script>

<template>
  <UCheckboxGroup
    v-model="q"
    :legend="legend"
    :size="size ?? 'xl'"
    :items="options.map(o => ({
      label: o.tagName,
      value: o.value,
      disabled: enabled && !enabled.has(o.value),
    }))"
    :ui="{
      ...ui,
      fieldset: [ui?.fieldset, 'gap-2 sm:gap-4 text-[var(--foreground,var(--color-seagreen-50))]'],
      legend: [ui?.legend, 'mb-11 font-semibold'],
      root: [ui?.root, 'text-[var(--foreground,var(--color-seagreen-50))]'],
    }"
  />
</template>
